<div class="tr-modal-wrapper">
    <div class="modal fade show d-block tr-modal level-up-modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-md modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body text-center">
                    <h4 class="mb-0 font-bold">{{ 'common.congratulations' | translate }}</h4>
                    <h5>{{ popTitle }}</h5>
                    <div class="row p-12 justify-content-center">
                        <div class="col-6">
                            <img class="level-up-glass" src="../../../../assets/img/level-up-glasses.svg">
                        </div>
                    </div>
                    <div class="p-12">
                        <p class="mb-0">{{ popMsg }}</p>
                    </div>
                    <button type="button" class="btn tr-btn-primary text-uppercase mt-2" (click)="closePopup()">{{ 'common.ok_great' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
    <div class="backdrop"></div>
</div>